import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {SelectableNavigationItem} from '../../model/selectable-navigation-item';
import {PageNames} from '../../shared/page-names.enum';
import {NavigationService} from '../../services/navigation/navigation.service';
import {TvShopStateService} from '../../services/state/tv-shop-state.service';

@Component({
  selector: 'app-checkbox-card',
  templateUrl: './checkbox-card.component.html',
  styleUrls: ['./checkbox-card.component.less']
})
export class CheckboxCardComponent extends SelectableNavigationItem implements OnInit, OnDestroy {
  @Input() id: string;
  @Input() titleKey: string;
  @Input() descriptionKey: string;
  @Input() badgeCopyKey: string;
  @Output() emitOnEnterPressed = new EventEmitter<string>();
  @Output() emitOnBack = new EventEmitter<boolean>();

  isCardSelected: boolean;

  constructor(
    private stateService: TvShopStateService,
    private navigationService: NavigationService,
    private cd: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this.navigationService.registerNavigation(this, PageNames.STREAMING_BUNDLE_OPTION);
  }

  activate(active: boolean): void {
    this.active = active;
    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onBack(): void {
    this.emitOnBack.emit(true);
  }

  onEnter(): void {
    this.isCardSelected = !this.isCardSelected;
    this.emitOnEnterPressed.next(this.id);
  }

}
